import React from 'react';
import { Button } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import {
	IMGUR_UPLOAD_FAILED,
	IMGUR_UPLOAD_REQUESTING,
	LABEL_IMGUR,
} from './const';
import { postToImgur } from './imgurApi';

export type P_ImgurButton = {
	imgurUrl: string;
	onGetImgurUrl: (url: string) => any;
	stageToDataUrl: () => string | undefined;
};
export default function ImgurButton(props: P_ImgurButton) {
	const upload = async () => {
		props.onGetImgurUrl(IMGUR_UPLOAD_REQUESTING);
		const uri = props.stageToDataUrl();
		if (!uri) {
			return;
		}
		const url = await postToImgur(uri);
		props.onGetImgurUrl(url ?? IMGUR_UPLOAD_FAILED);
	};

	return (
		<>
			<Button
				variant='contained'
				onClick={upload}
				startIcon={<UploadIcon />}
				disabled={props.imgurUrl === IMGUR_UPLOAD_REQUESTING}
			>
				{LABEL_IMGUR}
			</Button>
		</>
	);
}
